import Container from "layouts/container/Container";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext } from "react";
import DeskTopProductDetail from "./productDetail/DeskTopProductDetail";
import MobileProductDetail from "./productDetail/MobileProductDetail";
import DeskTopProductDetail2 from "./productDetail/DeskTopProductDetail2";
import DeskTopProductDetail3 from "./productDetail/DeskTopProductDetail3";

function ProductDetail() {
  const { isMobile } = useContext(BrowserDetectContext);
  return (
    <Container>
      {
        isMobile 
        ?
        <MobileProductDetail />
        :
        <DeskTopProductDetail3 />
      }
    </Container>
  );
}

export default ProductDetail;
